interface EventPromotionActionProps {
  label: string;
  onClick: () => void;
}

const EventPromotionAction = ({
  label,
  onClick,
}: EventPromotionActionProps) => (
  <div className="flex justify-center cursor-pointer text-custom-dark-blue mt-4 text-sm">
    <button type="button" onClick={onClick}>
      + {label}
    </button>
  </div>
);

export default EventPromotionAction;
